class MobileDetect {

	Init = () => {
		/*
		if(!!('ontouchstart' in window)){
			return true;
		}
		if($(window).width()<=1000){
			return true;
		}
		 */
		if ('ontouchstart' in window || navigator.maxTouchPoints) {
			return true;
		}

	};

}

export default new MobileDetect;